import { render } from "./ClinicsVision.vue?vue&type=template&id=578f9ab6"
import script from "./ClinicsVision.vue?vue&type=script&lang=js"
export * from "./ClinicsVision.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__